<template>
    <form class="product_search" @submit="searchPOS">
        <input type="text" placeholder="제품명을 입력해주세요." ref="searchKeyword" />
        <button>검색</button>
    </form>

    <div v-if="postData.list.length === 0" class="no-data">
        <p v-if="this.$route.query.keyword">
            <strong>"{{ this.keyword }}"</strong> 에 대한 검색결과가 없습니다.
        </p>
        <p v-else>등록된 제품이없습니다.</p>
        <button v-if="this.$route.query.keyword" @click="resetKeyword">검색 초기화</button>
    </div>

    <div class="product_list" v-else>
        <router-link :to="item.idx ? `${this.$route.path}/${item.idx}` : ''" class="product_item"
            v-for="(item, index) in postData.list" :key="item.idx">
            <div class="img_box" :class="{ 'no-image': imageErrors[index] }">
                <img :src="item.thumbPath || defaultImagePath" alt="" @error="setDefaultImage($event, index)" />
            </div>
            <p class="item_name">{{ item.productName }}</p>
            <p class="item_desc">{{ item.productDescription }}</p>
            <div class="top"></div>
            <div class="right"></div>
            <div class="bottom"></div>
            <div class="left"></div>
        </router-link>
    </div>
    <PaginationComponent :data="postData" />
</template>
<script>
import PaginationComponent from '@/components/PaginationComponent.vue';
import defaultImagePath from '@/assets/no_image.png';

export default {
    components: {
        PaginationComponent,
    },
    props: {
        postData: {},
    },
    data() {

        return {
            viewData: [],
            keyword: null,
            defaultImagePath,
            imageErrors: [],
        };
    },
    mounted() {
        this.viewData = this.postData.list;
        this.keyword = this.$route.query.keyword;

        if (this.$route.query.keyword) {
            const keyword = this.$route.query.keyword;
            this.$refs.searchKeyword.value = keyword;
        }
    },
    watch: {
        'postData.list': {
            handler(newList) {
                this.imageErrors = newList.map((item) => !item.thumbPath);
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        searchPOS: function (e) {
            e.preventDefault();
            this.keyword = this.$refs.searchKeyword.value;
            if (this.keyword === ''){
                this.resetKeyword(e);
                return;
            }
            this.$router.push({
                query: {
                    ...this.$route.query,
                    keyword: this.keyword,
                },
            });
        },
        resetKeyword: function (e) {
            e.preventDefault();
            this.keyword = null;
            this.$router.push({});
        },
        setDefaultImage(event, index) {
            if (typeof index === 'number') {
                this.imageErrors.splice(index, 1, true);
            }
            event.target.src = this.defaultImagePath; // 기본 이미지로 대체
        },
    },
};
</script>
<style lang="scss" scoped>
.no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    font-size: 20px;
    width: 100%;
    height: 400px;

    strong {
        color: var(--red);
    }

    button {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--red);
        color: #fff;
        font-size: 14px;
        padding: 0 10px;
        height: 36px;
        cursor: pointer;
    }
}

.product_search {
    width: 100%;
    display: flex;
    gap: 10px;
    padding: 35px 55px;
    background: #fafafa;
    margin-bottom: 70px;

    @media screen and (max-width: 768px) {
        padding: 30px;
        margin-bottom: 40px;
    }

    input[type='text'] {
        flex: 1 0 0;
        font-size: 18px;
        color: #333;
        padding: 0 28px;
        border: 1px solid transparent;

        &::placeholder {
            color: #ccc;
        }

        &:focus {
            outline: none;
            border: 1px solid #111;
        }

        @media screen and (max-width: 768px) {
            flex: auto;
            width: 100%;
            padding: 0 14px;
            font-size: 14px;

            &::placeholder {
                font-size: 14px;
            }
        }
    }

    button {
        flex: 0 0 180px;
        height: 60px;
        background: #333;
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        cursor: pointer;

        @media screen and (max-width: 768px) {
            flex: auto;
            width: 150px;
            height: 40px;
            font-size: 16px;
        }
    }
}

.product_list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 46px 36px;

    @media screen and (max-width: 1280px) {
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
    }

}

.product_item {
    position: relative;
    padding: 30px;
    border: 1px solid #ebebeb;

    .img_box {
        width: 100%;
        aspect-ratio: 1/1;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 30px;
        background: transparent;
        @media screen and (max-width: 768px) {
            height: auto;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        &.no-image {
            background: #fafafa;
        }    
    }

    .item_name {
        font-size: 22px;
        font-weight: 600;
        color: #111;
        line-height: 1;
        margin-bottom: 15px;

        @media screen and (max-width: 768px) {
            font-size: 18px;
            margin-bottom: 0;
        }
    }

    .item_desc {
        line-height: 1;
        font-size: 18px;
        color: #111;
    }

    .top {
        width: 100%;
        height: 3px;
        position: absolute;
        top: 0;
        left: 0;
        background: var(--orange);
        transition: 0.2s linear;
        transform-origin: left;
        transform: scaleX(0);
    }

    .right {
        width: 3px;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background: var(--orange);
        transition: 0.2s linear;
        transform-origin: top;
        transform: scaleY(0);
        transition-delay: 0.1s;
    }

    .bottom {
        width: 100%;
        height: 3px;
        position: absolute;
        bottom: 0;
        right: 0;
        background: var(--orange);
        transition: 0.2s linear;
        transform-origin: right;
        transform: scaleX(0);
        transition-delay: 0.2s;
    }

    .left {
        width: 3px;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        background: var(--orange);
        transition: 0.2s linear;
        transform-origin: bottom;
        transform: scaleY(0);
        transition-delay: 0.3s;
    }

    &:hover {
        box-shadow: 3px 3px 12px rgba(0, 0, 0, 0.1);

        .item_name {
            color: var(--orange);
        }

        .item_desc {
            color: var(--orange);
        }

        .top {
            transform: scaleX(1);
        }

        .right {
            transform: scaleY(1);
        }

        .bottom {
            transform: scaleX(1);
        }

        .left {
            transform: scaleY(1);
        }
    }
}
</style>
